import React from 'react';
import { StatusValue } from 'api/notifications/meta';
import { TaskType } from 'api/tasks';
import { StatusIndicatorIcon } from 'components/molecules/status-indicator';
import { Value } from '../../basics';

export const getStatusValue = (
  type: TaskType,
  { group, label }: StatusValue,
) => (
  <>
    <StatusIndicatorIcon type={type} group={group} />
    <Value>{label}</Value>
  </>
);
